import type { MoralClientDataDto } from '../dto';
import type { MoralClientData } from '../models';

export const mapMoralClientDataDtoToModel = (
  dto: MoralClientDataDto,
): MoralClientData => ({
  ...dto,
});
